module.exports = __webpack_public_path__ + "images/b74830e875d20d3c9f0aebeec57b72a8.svg";